import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "w100 pad40 with_white_bg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "centered fw600" }, "送信完了", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 centered mb20 mt20" }, [
  /*#__PURE__*/_createTextVNode(" 投票ページを作成し、メールを送信しました。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 調整するお相手が確定しない場合、2日後と調整ページから終了する前日にリマインドメールが自動送信されます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 「調整中」タブでもそれぞれの進捗を確認できます。"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "centered w100 mt40"
}
const _hoisted_6 = {
  key: 0,
  style: {"width":"500px","margin":"0 auto"}
}
const _hoisted_7 = { class: "centering" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fs16 fw600" }, "今回送信したユーザーをアドレス帳(グループ)に登録しますか？", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mt10 fs12" }, "アドレス帳(グループ)に登録すると使い回せて、次回の調整がもっとラクになります。", -1)
const _hoisted_12 = { class: "centering mt20" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { class: "centering" }
const _hoisted_17 = {
  key: 1,
  class: "pad40 centered"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", null, "アドレス帳(グループ)に登録しました", -1)
const _hoisted_20 = { class: "centering mt40" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = {
  key: 2,
  class: "centering",
  style: {"justify-content":"space-around"}
}
const _hoisted_24 = { class: "fw600 mt10 fs20" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_UrlWithQRcodeContent = _resolveComponent("UrlWithQRcodeContent")!

  return (_openBlock(), _createElementBlock("div", {
    class: "w100",
    style: _normalizeStyle(_ctx.height ? _ctx.height : `height: 100vh`)
  }, [
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      (_ctx.clg && _ctx.viewType == `will_save`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (!_ctx.currentClg.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/address_book.png`),
                      width: "18",
                      height: "18",
                      class: "mr10",
                      style: {}
                    }, null, 8, _hoisted_8),
                    _hoisted_9,
                    _hoisted_10
                  ]),
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clg.contact_lists, (mem, memindex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "fl mr10 posRe",
                        key: memindex
                      }, [
                        _createVNode(_component_UserIcon, {
                          member: mem,
                          width: 25,
                          canEdit: false,
                          updateSelf: false,
                          showTooltip: true,
                          class: "pointer"
                        }, null, 8, ["member"])
                      ]))
                    }), 128)),
                    _hoisted_13
                  ]),
                  _hoisted_14
                ]))
              : _createCommentVNode("", true),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_TextfieldTag, {
                class: "fl mt10",
                placeholder: `社内調整用`,
                value: _ctx.clg.name,
                onInputValue: _ctx.inputGroupName
              }, null, 8, ["value", "onInputValue"]),
              _createElementVNode("button", {
                type: "submit",
                class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 ml20",
                style: {"height":"50px"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createListGroup && _ctx.createListGroup(...args)))
              }, _toDisplayString(_ctx.Util.isPresent(_ctx.currentClg.name) ? `更新` : `作成`), 1)
            ])
          ]))
        : (_ctx.viewType == `saved`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/address_book.png`),
                width: "48",
                height: "48",
                style: {"margin-top":"-2px"}
              }, null, 8, _hoisted_18),
              _hoisted_19
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", {
          class: "pointer underline skyblue mt15",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goRooms && _ctx.goRooms(...args)))
        }, "調整ページ一覧へ"),
        _createElementVNode("div", {
          class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 ml20 fw600",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goSummary && _ctx.goSummary(...args)))
        }, " 投票状況を確認する "),
        _hoisted_22
      ]),
      (_ctx.generatedRoomsDic)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatedRoomsDic, (roomDic, roomindex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "mb20 w45 llgreyBg rad20 pad40",
                key: roomindex
              }, [
                _createElementVNode("p", _hoisted_24, _toDisplayString(roomDic.member.name) + " 様", 1),
                _hoisted_25,
                _createVNode(_component_UrlWithQRcodeContent, {
                  index: roomindex,
                  url: roomDic.room_link
                }, null, 8, ["index", "url"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 4))
}